import { useContext, useEffect, useRef, useState } from "react";
import { ContextMenu } from "../menu";
import { getUser, logout } from "../../../helpers/user";
import "./styles.scss";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navegate = useNavigate();

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const context = useContext(ContextMenu);
  const {
    customCliente: { imgFaixa, nomeFantasia, primaryColor },
  } = getUser();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="main-header" style={{ borderTopColor: primaryColor }}>
      <section className="containerHeader">
        <button
          className="main-header__btn-toggle"
          title={""}
          onClick={() => context.setMenuIsOpen()}
        >
          <i className="fa-solid fa-bars"></i>
        </button>

        <img className="main-header__brand" src={imgFaixa} alt={nomeFantasia} />
      </section>

      <nav
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div ref={dropdownRef} style={{ position: "relative" }}>
          {window.location.pathname !== "/perfil" && (
            <>
              <button
                onClick={() => navegate("/perfil")}
                style={{
                  backgroundColor: primaryColor,
                  outline: "none",
                  border: "none",
                  color: "#fff",
                  marginRight: "10px",
                  padding: "10px 10px",
                  borderRadius: "4px",
                  width: "8rem",
                  cursor: "pointer",
                }}
              >
                Meu Perfil
              </button>
            </>
          )}
        </div>
        <div className="user-avatar">
          <Button variant="tertiary" size="sm" onClick={() => logout()}>
            sair
          </Button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
